import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'sendemail',

  type : 'module',
  
  label: 'envoi d\'email',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-email',
  }
}